import ZincFull from 'marketing-website/components/icons/ZincFull';
import statsImage from 'marketing-website/media/images/pages/case-studies/zinc/stats@2x.jpg';
import image01a from 'marketing-website/media/images/pages/case-studies/zinc/image-01-a@2x.jpg';
import image01b from 'marketing-website/media/images/pages/case-studies/zinc/image-01-b@2x.jpg';
import image02a from 'marketing-website/media/images/pages/case-studies/zinc/image-02-a@2x.jpg';
import image02b from 'marketing-website/media/images/pages/case-studies/zinc/image-02-b@2x.jpg';
import image03a from 'marketing-website/media/images/pages/case-studies/zinc/image-03-a@2x.jpg';
import image03b from 'marketing-website/media/images/pages/case-studies/zinc/image-03-b@2x.png';
import image05a from 'marketing-website/media/images/pages/case-studies/zinc/image-05-a@2x.jpg';
import image05b from 'marketing-website/media/images/pages/case-studies/zinc/image-05-b@2x.jpg';
import image06a from 'marketing-website/media/images/pages/case-studies/zinc/image-06-a@2x.jpg';
import image06b from 'marketing-website/media/images/pages/case-studies/zinc/image-06-b@2x.png';
import imageQuote from 'marketing-website/media/images/pages/case-studies/zinc/quote@2x.jpg';

const zincAssets = {
  heroLogo: ZincFull,
  statsImage: {
    alt: 'Zinc and Marvel Prototyping',
    maxWidth: 1290,
    src: statsImage,
  },
  stats: [
    {
      id: 0,
      stat: '55',
      title: 'skilled individuals',
      copy:
        'From 800 applicants to their programme Zinc chooses a diversely skilled 55.',
    },
    {
      id: 1,
      stat: '2',
      title: 'week bootcamp',
      copy:
        'Successful applicants are given an overview of the challenge they’re solving.',
    },
    {
      id: 2,
      stat: '6',
      title: 'month programme',
      copy:
        'Helping them find business partners, gain access to funding, industry leaders and resources.',
    },
  ],

  doubleImages: {
    first: [
      {
        src: image01a,
        maxWidth: 550,
        alt: 'Zinc Events',
      },
      {
        src: image01b,
        maxWidth: 550,
        alt: 'Zinc Events',
      },
    ],
    second: [
      {
        src: image02a,
        maxWidth: 556,
        alt: 'Zinc and Amble',
      },
      {
        src: image02b,
        maxWidth: 556,
        alt: 'Amble and Marvel',
      },
    ],
    third: [
      {
        src: image03a,
        maxWidth: 536,
        alt: 'Leika uses Marvel',
      },
      {
        src: image03b,
        maxWidth: 500,
        alt: 'Leika and Marvel App',
      },
    ],
    fourth: [
      {
        src: imageQuote,
        maxWidth: 556,
        alt: 'Squad uses Marvel App',
      },
      {
        maxWidth: 490,
        copy:
          '“It’s one thing saying we’re going to create something but once you start making it on Marvel it’s not just a prototype to show to investors anymore. It’s also a tool to get your head straight and make both small scale design decisions and the high level decisions.”',
      },
    ],
    fifth: [
      {
        src: image05a,
        maxWidth: 550,
        alt: 'Zone and Marvel App',
      },
      {
        src: image05b,
        maxWidth: 550,
        alt: 'Zone prototypes with Marvel',
      },
    ],
    sixth: [
      {
        src: image06a,
        maxWidth: 550,
        alt: 'Zinc Events',
      },
      {
        src: image06b,
        maxWidth: 550,
        alt: 'Zinc founder, Julia',
      },
    ],
  },
};

export default zincAssets;



// WEBPACK FOOTER //
// ./src/configs/caseStudies/zinc.js